import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/customers',
    name: 'customers',
    meta: {
      title: 'Customers'
    },
    component: () => import('@/views/customers/CustomerListView.vue')
  },
  {
    path: '/customers/create',
    name: 'customer-create',
    meta: {
      title: 'Create Customer'
    },
    component: () => import('@/views/customers/CustomerCreateView.vue')
  },
  {
    path: '/customers/:id',
    name: 'customer-edit',
    props: true,
    meta: {
      title: 'Edit Customer'
    },
    component: () => import('@/views/customers/CustomerEditView.vue'),
    children: [
      {
        path: '/customers/:id/f/:section',
        name: 'customer-edit-section',
        props: true,
        meta: {
          title: 'Edit Customer'
        },
        component: () => import('@/views/customers/CustomerEditView.vue')
      }
    ]
  }
]

export default routes
